import React, { FC, ReactNode, } from 'react';
import styles from './style.module.css';

interface ServicesWrapperProps {
  children: ReactNode;
}

export const ServicesWrapper: FC<ServicesWrapperProps> = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>;
};